// extracted by mini-css-extract-plugin
export default {"backgroundColor":"Nav_backgroundColor__uhgC9","nav":"Nav_nav__ZVcnH","pointer":"Nav_pointer__Bb2FP","menu":"Nav_menu__KlHs1","close":"Nav_close__-D0aT","bars":"Nav_bars__KvSKD"};